function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["initialPageParam", "queryKey", "queryFn", "enabled", "select"];
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { useMemo } from "react";
import { useInfiniteQuery, useQueryClient } from "@tanstack/react-query";
import { useMemoizedFn } from "@firefly/fly-hook";
import throwOnSecurityException from "./throwOnSecurityException";
function selectNodes(connection) {
  return connection.nodes;
}
export function useInfiniteConnectionQuery(options) {
  var initialPageParam = options.initialPageParam,
    queryKey = options.queryKey,
    _queryFn = options.queryFn,
    _options$enabled = options.enabled,
    enabled = _options$enabled === void 0 ? true : _options$enabled,
    _options$select = options.select,
    _select = _options$select === void 0 ? selectNodes : _options$select,
    rest = _objectWithoutProperties(options, _excluded);
  var queryClient = useQueryClient();
  var queryResult = useInfiniteQuery(_objectSpread(_objectSpread({}, rest), {}, {
    queryKey: queryKey,
    initialPageParam: {},
    queryFn: function queryFn(context) {
      return _queryFn(context);
    },
    throwOnError: throwOnSecurityException,
    enabled: enabled,
    getNextPageParam: function getNextPageParam(lastPage, _allPages) {
      var pageInfo = lastPage.pageInfo;
      return pageInfo !== null && pageInfo !== void 0 && pageInfo.hasNextPage ? {
        after: pageInfo.endCursor
      } : undefined;
    }
  }));
  function reset() {
    return queryClient.resetQueries({
      queryKey: queryKey
    });
  }
  var data = queryResult.data,
    isFetching = queryResult.isFetching,
    hasNextPage = queryResult.hasNextPage,
    fetchNextPage = queryResult.fetchNextPage;
  var select = useMemoizedFn(_select);
  var items = useMemo(function () {
    if (data) {
      return data.pages.reduce(function (result, connection) {
        return [].concat(_toConsumableArray(result), _toConsumableArray(select(connection)));
      }, []);
    }
    return undefined;
  }, [data]);
  var isEmpty = (items === null || items === void 0 ? void 0 : items.length) === 0;
  return _objectSpread(_objectSpread({}, queryResult), {}, {
    // searchParams,
    // setSearchParams,
    items: items,
    reset: reset,
    isEmpty: isEmpty,
    hasMore: hasNextPage,
    loadMore: function loadMore() {
      if (isFetching) {
        // return Promise.reject('loadMore failure, isFetching');
        return Promise.resolve();
      }
      if (!hasNextPage) {
        return Promise.reject('loadMore failure, no more');
      }
      return fetchNextPage().then();
    }
  });
}